import { SvgIcon, SvgIconProps } from '@mui/material';

const FilterOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="FilterOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00015 22H15.0001V11.5752L21.9639 2H2.03638L9.00015 11.5752V22ZM11.0001 20V10.9248L5.96392 4H18.0364L13.0001 10.9248V20H11.0001Z"
      />
    </SvgIcon>
  );
};

export default FilterOutlined;
